<template>
  <div>
    <iModal
      title="添加供需类别"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="500px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="130"
            @submit.native.prevent
          >
            <FormItem label="供需名称：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="英文供需名称：" prop="nameEn">
              <Input v-model="formInline.nameEn" />
            </FormItem>
            <FormItem label="类型颜色：" prop="color" class="colorSel">
              <ColorPicker v-model="color" />
            </FormItem>
            <FormItem label="显示顺序：" prop="showIndex">
              <InputNumber :max="99999999" :min="-10" v-model="formInline.showIndex"></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  // 新增人员modal
  name: "supply-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      showModal: true,
      time: [],
      formInline: {
        // form双向绑定
        name: "",
        nameEn: "",
        showIndex: 0
      },
      color: "#000",
      ruleInline: {
        name: [{ required: true, message: "供需名称不能为空", trigger: "blur" }],
        nameEn: [{ required: true, message: "英文展品类别不能为空", trigger: "blur" }],
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  created() {
    if (this.editInfo) {
      this.formInline.name = this.editInfo.name;
      this.formInline.nameEn = this.editInfo.nameEn;
      this.color = this.editInfo.color;
      this.formInline.showIndex = this.editInfo.showIndex;
    }
  },
  methods: {
    ...mapActions({
      editReleaseType: "momentModule/editReleaseType"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Id: this.editInfo.id,
        SetValues: {
          Name: form.name,
          NameEn: form.nameEn,
          Color: this.color || "#000",
          ShowIndex: form.showIndex
        }
      }; 
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.editReleaseType(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.colorSel {
  .ivu-select-dropdown {
    width: auto;
  }
}
</style>
<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

